import { createSlice } from '@reduxjs/toolkit'
import { DataList } from '../common'
import {
  fetchArticles,
  fetchLayoutableStatus,
  bulkCreateArticles,
  createArticle,
  deleteFigure,
  modifyArticle,
  modifyPage,
  modifySubLayout,
  modifyHeading,
  modifyTemplateArticle,
  createFigure,
  modifyFigure,
  modifyArea,
  deleteArticles,
  startLayout,
  switchArticleOrders,
  bulkOperateFigures
} from './articleAPI'
import type { Article, ArticleState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  selectCellReducer,
  setLayoutableLockVersionReducer,
  selectTargetArticleReducer,
  openModalReducer,
  closeModalReducer,
  closeAlertReducer,
  dismissErrorReducer,
  setAlertReducer,
  buildExtraReducers
} from './articleReducer'

const initialState: ArticleState = {
  sort: { column: 'id', order: 'desc' },
  selectedIds: [],
  selectedCell: null,
  selectedArticle: null,
  layoutableType: null,
  layoutable: null,
  openedModal: null,
  ...DataList.initialState,
  data: [] as Article[],
  errors: {},
  alert: { show: false, title: null, alertBody: null }
}

export const articleSlice = createSlice({
  name: 'article',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn,
    selectPage: DataList.selectPage,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    selectCell: selectCellReducer,
    setLayoutableLockVersion: setLayoutableLockVersionReducer,
    selectTargetArticle: selectTargetArticleReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    closeAlert: closeAlertReducer,
    dismissError: dismissErrorReducer,
    setAlert: setAlertReducer
  },
  extraReducers: (builder) =>
    buildExtraReducers(builder, {
      fetchArticles,
      fetchLayoutableStatus,
      bulkCreateArticles,
      createArticle,
      deleteFigure,
      modifyArticle,
      modifyPage,
      modifySubLayout,
      modifyHeading,
      modifyTemplateArticle,
      createFigure,
      modifyFigure,
      modifyArea,
      deleteArticles,
      startLayout,
      switchArticleOrders,
      bulkOperateFigures
    })
})

export const {
  selectColumn,
  selectPage,
  selectId,
  selectCell,
  selectTargetArticle,
  setLayoutableLockVersion,
  unselectId,
  openModal,
  closeModal,
  closeAlert,
  dismissError,
  setAlert
} = articleSlice.actions

export { selectArticlesLayoutable, selectArticle, selectLayoutableTitleWithMargin } from './articleSelectors'
